import { SubmitHandler } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import adaptCreateBanner from "src/features/HomepageCarouselBanners/adapters/adaptCreateBanner";
import CreateBannerForm from "src/features/vendorSponsorshipAdmin/components/CreateBannerForm/CreateBannerForm";
import VENDOR_FULL_PAGE_TAKEOVER_FORM from "../../constants/vendorStepsForm";
import useCreateFullScreenTakeover from "../../hooks/useCreateFullScreenTakeover/useCreateFullScreenTakeover";

const CreateFullScreenTakeover = () => {
	const navigate = useNavigate();

	const defaultValues: BannerFormState = {
		bannerStyle: "standard",
		bannerType: "fullScreenTakeoverBanner",
		selectedHashtag: null,
		steps: VENDOR_FULL_PAGE_TAKEOVER_FORM
	};

	const { mutate: createFullScreenTakeoverBanner } =
		useCreateFullScreenTakeover();

	const onSuccess = () => {
		toast.success(<CustomToast type="Success" message="Saved Successfully" />);
		navigate(
			"/vendor-sponsorship/full-screen-takeover/banners?published=false"
		);
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="There is an error creating the form" />
		);
	};

	const onSubmit: SubmitHandler<BannerFormState> = (data) => {
		console.log("FORM IS VALID, SUBMIT FORM", data);

		createFullScreenTakeoverBanner(adaptCreateBanner(data), {
			onSuccess,
			onError
		});
	};

	return (
		<CreateBannerForm
			onSubmit={onSubmit}
			defaultValues={defaultValues}
			bannerTypeRadioOptions={["fullScreenTakeoverBanner"]}
			showBannerTypePicker={false}
			root="full-screen-takeover"
		/>
	);
};

export default CreateFullScreenTakeover;
